import { Component, OnInit } from '@angular/core';
import { MenuComponent } from '@infra-ui/components/menu/menu.component';
import {
  IonRouterOutlet,
} from '@ionic/angular/standalone';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss'],
  standalone: true,
  imports: [IonRouterOutlet, MenuComponent],
})
export class MainLayoutComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
